import { createRouter, createMemoryHistory, createWebHashHistory, createWebHistory } from 'vue-router'

export function makeRouter(props: any) {
    const history = props.routerMode === 'memory'
        ? createMemoryHistory()
        : props.routerMode === 'web'
            ? createWebHistory(props.routerBase ?? '/')
            : createWebHashHistory(props.routerBase ?? '/')

    return createRouter({
        history,
        routes: [
            {
                path: '/',
                component: () => import('./components/pages/widget.vue'),
                // ✅ Route props aus query/initial props
                props: (route) => {
                    function qn(key: string): number | null {
                        const v = route.query[key]
                        if (v == null) return null
                        const n = Number(Array.isArray(v) ? v[0] : v)
                        return Number.isFinite(n) && n > 0 ? n : null
                    }
                    return {
                        categoryId: qn('category') ?? qn('categoryId'),
                        productId: qn('product') ?? qn('productId'),
                        autoNavigateToEditor: route.query.auto === '1',
                    }
                },
            },
            { path: '/stock-import', component: () => import('./components/pages/stock-import.vue') },
            { path: '/multi', component: () => import('./components/pages/multi.vue') },
            { path: '/single', component: () => import('./components/pages/single.vue') },
            // Layer-/Design-Editor (editorConfig.mode = 'design'); wird in Phase 5 ausgebaut.
            { path: '/design', component: () => import('./components/pages/design.vue') },
            { path: '/quick-upload', component: () => import('./components/pages/quick-upload.vue') },
            { path: '/mobile-upload', component: () => import('./components/pages/mobile-upload.vue') },
        ],
    })
}
